// extracted by mini-css-extract-plugin
export default {"content":"pkyFUSLUeRe9ZAXAKUb3"};